<section
  data-cy="search-result-not-found"
  class="search-result-not-found-section"
  [ngClass]="{ 'old-search-text': !isNewSearch }"
>
  <p
    *ngIf="searchLoadingState !== SearchLoadingState.error"
    class="search-result-title"
    data-cy="search-result-not-found-title"
  >
    {{
      'i18n.search.noSearchResults.noMatches' | translate: { product: search }
    }}
  </p>
  <p
    *ngIf="!isNewSearch && searchLoadingState !== SearchLoadingState.error"
    class="try-again-message"
    data-cy="search-result-not-found-message"
  >
    {{ 'i18n.search.noSearchResults.pleaseTryAgain' | translate }}
  </p>
  <ng-container *ngIf="isNewSearch">
    <div
      *ngIf="searchLoadingState === SearchLoadingState.error"
      class="not-found-error"
    >
      <div class="not-found-error-img">
        <img src="assets/images/new-search-not-found-error.png" />
      </div>
      <p class="not-displayed-paragraph">
        {{ 'i18n.search.noSearchResults.notDisplayed' | translate }}.
      </p>
      <p class="problem-paragraph">
        {{ 'i18n.search.noSearchResults.thereWasProblem' | translate }}&nbsp;{{
          search | addSingleQuotes
        }}
        <a (click)="refresh()">.Click here</a> to try again
      </p>
    </div>
    <p
      *ngIf="
        searchLoadingState !== SearchLoadingState.error && !hasFacetsSelected
      "
      class="try-again-message"
    >
      {{ 'i18n.search.noSearchResults.refineSearch' | translate }}
    </p>
    <div
      class="zero-filter-container"
      [class.mobile]="platformService.platformType === platformEnum.mobile"
      [class.tablet]="platformService.platformType === platformEnum.tablet"
      *ngIf="
        searchLoadingState !== SearchLoadingState.error && hasFacetsSelected
      "
    >
      <ion-text class="clear-filters-text">
        {{ 'i18n.search.noSearchResults.doWantClearFilters' | translate }}
      </ion-text>
      <ion-button
        (click)="clearFacets()"
        class="usf-outline-green-button clear-filters-button"
      >
        {{ 'i18n.search.noSearchResults.yesClearFilters' | translate }}
      </ion-button>
    </div>
  </ng-container>
</section>
<section
  class="top-seller-section"
  [ngClass]="{ 'old-search-text': !isNewSearch, 'new-search': isNewSearch }"
  *ngIf="topSellers?.length > 0 || coveoTopSellers?.length > 0"
>
  <ng-container *ngIf="!useCoveoTopSellers">
    <app-merchandising-product-carousel
      [title]="'i18n.productDetail.recommendations.topSellers' | translate"
      [products]="topSellers"
      [platformType]="platformService?.platformType"
      (quantityUpdateEmitter)="onQuantityUpdate($event)"
      (productClickEmitter)="emitProductCardClick($event)"
      [linkSource]="lnkSrc"
      [merchFeature]="TOP_SELLER_FEATURE_NAME"
      [addMethod]="TOP_SELLER_FEATURE_NAME"
      [isGuestUser]="isGuestUser"
    ></app-merchandising-product-carousel>
  </ng-container>
  <ng-container *ngIf="useCoveoTopSellers">
    <app-recommendation-carousel
      [title]="'i18n.productDetail.recommendations.topSellers' | translate"
      [products]="coveoTopSellers"
      [platformType]="platformService?.platformType"
      (quantityUpdateEmitter)="onQuantityUpdate($event)"
      (productClickEmitter)="emitCoveoProductCardClick($event)"
      [linkSource]="lnkSrc"
      [addMethod]="TOP_SELLER_FEATURE_NAME"
    >
    </app-recommendation-carousel>
  </ng-container>
</section>
